module.exports = __webpack_public_path__ + "7d3888f1284bca52587430b909eb2ad5.svg";